import './SliderNotchLabel.e84fd4bedf5ac8e393aed06b528e8fc7.css';
export default {"container":"_container_393ix_1","label":"_label_393ix_1"};